const MASKING_SEED = 'autofi-demo-mode-v1';
const LOWER_SCALER_COUNT = 3;
const UPPER_SCALER_COUNT = 4;

const randomInRange = (min: number, max: number): number => {
  return Number((min + Math.random() * (max - min)).toFixed(2));
};

const createAmountScalers = (): number[] => {
  const lowerScalers = Array.from({ length: LOWER_SCALER_COUNT }, () => randomInRange(0.52, 0.95));
  const upperScalers = Array.from({ length: UPPER_SCALER_COUNT }, () => randomInRange(1.05, 1.85));
  const merged = [...lowerScalers, ...upperScalers];

  return merged.sort(() => Math.random() - 0.5);
};

let amountScalers = createAmountScalers();

const hashString = (value: string): number => {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }

  return hash >>> 0;
};

export const regenerateAmountScalers = (): void => {
  amountScalers = createAmountScalers();
};

export const randomizeDisplayAmount = (amount: number): number => {
  if (!Number.isFinite(amount)) {
    return amount;
  }

  const sign = amount < 0 ? -1 : 1;
  const absoluteAmount = Math.abs(amount);
  const normalizedAmount = Number(absoluteAmount.toFixed(2));
  const seed = hashString(`${MASKING_SEED}:${normalizedAmount.toFixed(2)}`);
  const scaler = amountScalers[seed % amountScalers.length];
  const isZeroAmount = normalizedAmount === 0;

  // Zero values still get masked to a deterministic non-zero demo value.
  let randomizedAbsoluteAmount = (isZeroAmount ? 100 : absoluteAmount) * scaler;

  if (!isZeroAmount && absoluteAmount < 1) {
    randomizedAbsoluteAmount = Math.min(0.99, Math.max(0.1, randomizedAbsoluteAmount));
  }

  return sign * Number(randomizedAbsoluteAmount.toFixed(2));
};
